import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select';

// A rule value list built from a Salesforce or HubSpot vocabulary runs past twenty
// values, where SlimSelect swaps the deletable pills for a bare "{n} selected" badge.
// These keep removal reachable: pills through 50 (the check is `>`), a dropdown row that
// deselects on click, and a menu that stays open, since a close also clears the search.
//
// Multi-selects only: on a single select allowDeselect can empty a required field.
const MULTIPLE_SELECT_SETTINGS = {
  maxValuesShown: 50,
  allowDeselect: true,
  closeOnSelect: false
};

// Every addable select shares this check. A pipeline rule stores its values joined by "|", so a
// typed value holding one would be saved as two values while it previewed as one. SlimSelect
// shows the Error's message in the dropdown.
function addableValue(value) {
  const trimmed = value.trim()
  if (!trimmed) return false
  if (trimmed.includes("|")) return new Error('"|" separates values. Add each value on its own.')

  return trimmed
}

export default class extends Controller {
  static values = {
    options: Object,
    // Lets typed search text be kept as its own value, beside the listed options: a Match
    // rule fragment like "SEM", or a column the Predict wizard's list doesn't offer yet. A
    // callback cannot travel through the JSON `options` value, so it is switched on here.
    addable: Boolean
  };

  // SlimSelect dispatches a bubbling `change` on the native select for every selection, when
  // it writes the new options back (Select#updateOptions). Do not dispatch another from
  // `afterChange`: that event also reaches SlimSelect's own change listener, which writes the
  // options again and dispatches a third. A `change` action that navigates (rule-select) then
  // sends the same request more than once.
  connect() {
    this.slimselect = new SlimSelect({
      select: this.element,
      events: {
        ...(this.addableValue ? { addable: (value) => addableValue(value) } : {})
      },
      settings: {
        showSearch: true,
        searchText: 'No results',
        searchPlaceholder: 'Search...',
        searchHighlight: true,
        ...(this.element.multiple ? MULTIPLE_SELECT_SETTINGS : {})
      },
      ...this.optionsValue,
    });

    this.element.slimselect = this.slimselect;
  }

  disconnect() {
    this.slimselect.destroy();
  }
}
